let offsetMs = 0;

export const updateServerClockOffset = (dateHeader: string | undefined): void => {
    if (!dateHeader) return;
    const serverTime = new Date(dateHeader).getTime();
    if (isNaN(serverTime)) return;
    offsetMs = serverTime - Date.now();
};

export const getServerNow = (): Date => new Date(Date.now() + offsetMs);
